/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_Marketing_DescInputs */

const en_mk_mock_agent_marketing_desc = /** @type {(inputs: Mk_Mock_Agent_Marketing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption drafts, content calendar, competitor recaps.`)
};

const id_mk_mock_agent_marketing_desc = /** @type {(inputs: Mk_Mock_Agent_Marketing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf caption, kalender konten, rekap kompetitor.`)
};

/**
* | output |
* | --- |
* | "Caption drafts, content calendar, competitor recaps." |
*
* @param {Mk_Mock_Agent_Marketing_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_marketing_desc = /** @type {((inputs?: Mk_Mock_Agent_Marketing_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_Marketing_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_marketing_desc(inputs)
	return en_mk_mock_agent_marketing_desc(inputs)
});